import React from "react";

class Start_Main_Start_Button_Image extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            src:props.src,
            alt:props.alt
        }
    }
    render() {
        return(
            <img className="start_main_start_button_image" src={this.state.src} alt={this.state.alt} />
        )
    }
}

export default Start_Main_Start_Button_Image;